import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { CARD_WRAPPER_TYPES } from '../../../shared/constants';
import { IImage } from '../../../types/shared';

import { parseSectionID } from '../../../utils/string-utils';

import mq from '../../../styles/breakpoints';
import Colors from '../../../styles/colors';
import { ProductPageH2 } from '../../../styles/generic';

interface Props {
  image: IImage;
  title: string;
  children: ReactNode;
  anchorName?: string;
}

const GatedContentWrapper = ({ image, title, children, anchorName }: Props) => {
  const id = parseSectionID(CARD_WRAPPER_TYPES.gatedContentWrapper, anchorName);

  return (
    <section id={id} data-testid={CARD_WRAPPER_TYPES.gatedContentWrapper}>
      {title && <ProductPageH2 data-testid="title">{title}</ProductPageH2>}
      <Wrapper>
        <div data-testid="form-container">{children}</div>
        {image.gatsbyImageData ? (
          <ImageContainer
            image={image.gatsbyImageData?.images?.fallback?.src}
            data-testid="image-container"
          />
        ) : undefined}
      </Wrapper>
    </section>
  );
};

export default GatedContentWrapper;

const Wrapper = styled.div`
  align-items: stretch;
  background-color: ${Colors.white};
  box-shadow: ${({ theme }) => theme.elevations.abnElevationTile};
  display: flex;
  flex-direction: column-reverse;

  ${mq.from.breakpoint.L`
    flex-direction: row;
  `}
`;

const ImageContainer = styled.div<{ image: string }>`
  background-image: url(${({ image }: { image: string }) => image});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 311px;
  width: 100%;

  ${mq.from.breakpoint.M`
    display: none;
  `}

  ${mq.from.breakpoint.L<{ image: string }>`
    ${({ image }: { image: string }) => `
    background-image: url("${image}`}");
    background-position: center;
    background-repeat: no-repeat;
    height: inherit;
    flex-shrink: 0;
    display: flex;
    position: relative;
    overflow: hidden;
    margin: 40px 40px 40px 0;
    flex-shrink: 0;
    width: 40%;
  `};

  ${mq.from.breakpoint.XL`
    width: 516px;
  `}
`;
